import { useState } from "react";
import { ProductRail } from "@/components/ProductCard";
import { getRecent, clearRecent } from "@/lib/recentlyViewed";
import { useCompare, COMPARE_MAX } from "@/context/CompareContext";
import { X, GitCompare } from "lucide-react";

// A "jump back to what you were looking at" strip. Renders nothing until the
// shopper has viewed at least 2 products.
export function RecentlyViewed({ excludeId = null, title = "Recently Viewed" }) {
  const [items, setItems] = useState(() => getRecent().filter((p) => p && p.id && p.id !== excludeId));
  const { toggleCompare, inCompare } = useCompare();
  if (items.length < 2) return null;
  const clear = () => { clearRecent(); setItems([]); };
  const compareThese = () => { items.slice(0, COMPARE_MAX).forEach((p) => { if (!inCompare(p.id)) toggleCompare(p); }); };
  return (
    <div data-testid="recently-viewed">
      <ProductRail
        title={title}
        products={items}
        action={
          <div className="flex items-center gap-4">
            <button onClick={compareThese} data-testid="compare-recent-btn"
              className="text-sm font-semibold text-emerald hover:text-emerald-deep inline-flex items-center gap-1 transition-colors">
              <GitCompare size={15} /> Compare
            </button>
            <button onClick={clear} data-testid="clear-recent-btn"
              className="text-sm text-muted-foreground hover:text-coral font-semibold inline-flex items-center gap-1 transition-colors">
              <X size={15} /> Clear
            </button>
          </div>
        }
      />
    </div>
  );
}
